import React, { useEffect } from "react";
import { Collapse, Typography } from "antd";
import { useData } from "../contexts/DataContext";
import { fetchFaqs } from "../services/ApiService";
import { FAQ } from "../models/Faq"; // Import the FAQ model
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const { Title } = Typography;
const { Panel } = Collapse;

interface Props {
  modal: boolean;
}

const FAQs: React.FC<Props> = ({ modal }) => {
  const { state, dispatch } = useData();
  const faqs = [...(state.faqs ?? [])].sort((a: FAQ, b: FAQ) => {
    const aSortOrder = a.sortOrder ?? Number.MAX_SAFE_INTEGER;
    const bSortOrder = b.sortOrder ?? Number.MAX_SAFE_INTEGER;

    if (aSortOrder !== bSortOrder) {
      return aSortOrder - bSortOrder;
    }

    return a.id - b.id;
  });

  useEffect(() => {
    // Check if FAQs data has already been fetched
    if (!state.faqs) {
      // If FAQs data hasn't been fetched, fetch it
      fetchFaqs(dispatch);
    }
  }, [dispatch, state.faqs]);

  return (
    <div style={{ width: modal ? "100%" : "90%" }}>
      {!modal && <Title level={2}>FAQs</Title>}
      <Collapse accordion>
        {faqs.map((faq: FAQ) => (
          <Panel header={faq.Question} key={faq.id}>
            <BlocksRenderer content={faq.Answer}></BlocksRenderer>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default FAQs;
